import { useTranslation } from '@flecto/translations'
import { Modal, type ModalProps } from '@flecto/ui'

interface ModalUnlinkIdentityProps extends ModalProps {
  onConfirm: () => void
}

export function ModalUnlinkIdentity({ onConfirm }: ModalUnlinkIdentityProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_account' })

  return (
    <Modal size='sm'>
      <Modal.Icon variant='warning' />
      <Modal.Title>{t('modal_unlink_identity.title')}</Modal.Title>
      <Modal.Content>
        {t('modal_unlink_identity.content')}
      </Modal.Content>
      <Modal.Cancel />
      <Modal.Submit onClick={onConfirm} />
    </Modal>
  )
}
